
  // data/tabsData.js (example file - or just define inline)
export const tabsData = [
  {
    id: 'overview',
    title: 'Overview',
    images: [
      { src: '/images/SingWhatYouMean_1.jpg', alt: 'Workshop participant experimenting with music - Image 1' },
      { src: '/images/SingWhatYouMean_4.jpg', alt: 'Workshop participant playing instruments - Image 2' },
    ],
    content: (
      <>
        <p className="mb-4 text-justify">
        The Sing What You Mean, Mean What You Play project was all about giving neurodivergent
young people the opportunity to explore music in ways that felt authentic, accessible, and
empowering. We partnered with two schools, with the support of our incredible programme
coordinators at <b>Buzzing Roots</b>, led by <b>Nicola Middler</b>, and made possible through funding
from <b>Youth Music UK</b>.

        </p>
        <p className="mb-4 text-justify">
        Working with children aged 5–11, the project aimed to create a space where creativity, self-
expression, and confidence could grow through music. My role, alongside Akshay Sharma 
<b> (Mr Shay)</b>, was to co-design and deliver sessions that were child-led and responsive, while
also supporting teachers and families through CPD so the impact could carry on beyond our
workshops.
        </p>

      </>
    ),
  },
  {
    id: 'activities',
    title: 'Activities',
    images: [
      // { src: '/images/SingWhatYouMean_3.jpg', alt: 'Children engaging in music activities - Image 3' },
      { src: '/images/spark_v2_3.jpg', alt: 'Workshop participant experimenting with music - Image 1' },
    ],
    content: (
      <>
        <p className="mb-4 text-justify">
        Each session began with engaging games like “Pass the Clap,” “Don’t Clap This One Back,”
and voice-projection activities—fun, simple ways to build connection, focus, and confidence.
We introduced creative tools like loop pedals, digital audio workstations, and journaling,
allowing children to express themselves in the ways that suited them best.
        </p>
        <p className="mb-4 text-justify">
        The sessions were kept small and flexible. At one school, group dynamics worked
beautifully, while at the other, one-on-one activities were more effective. We always made
space for autonomy and quiet reflection, and a calm room was available during every
session for children needing a sensory break.
        </p>
      </>
    ),
  },
  {
    id: 'challenges',
    title: 'Challenges',
    images: [
      { src: '/images/spark_v2_4.jpg', alt: 'Workshop participant playing instruments - Image 2' },
    ],
    content: (
      <>
        <p className="mb-4 text-justify">
          <b>Behavior and Focus at School 1</b> <br />
          School 1 presented some challenges around behaviour and focus, particularly during open-
ended or unstructured activities. To address this, we invited the children to co-create session
rules and expectations. This helped instil a sense of ownership, and once in place, it
noticeably improved participation and energy.
        </p>
        <p className="mb-4 text-justify">
          <b>Reserved Nature at School 2</b> <br />
          School 2 was much more reserved. Many of the children preferred quiet, individual activities
and needed extra time to feel comfortable expressing themselves. Journaling, solo sound
exploration, and gentle structure gave them the space to engage in their own time.
        </p>
        <p className="mb-4 text-justify">
          <b>Balancing Individual and Group Dynamics</b> <br />
          Navigating these different needs reinforced the importance of listening, flexibility, and
creating environments where every kind of learner feels seen, supported, and safe.
        </p>
      </>
    ),
  },
  {
    id: 'reflection',
    title: 'Reflection',
    images: [
      { src: '/images/spark_v2_5.jpg', alt: 'Children engaging in music activities - Image 3' },
    ],
    content: (
      <>
        <p className="mb-4 text-justify">
        Some of the most powerful moments came when we found the right creative tools for each
child. One participant thrived with the loop pedal, lighting up while layering their own voice
and beats. Another was most engaged when working solo in the digital audio workstation,
completely immersed in the process. Others connected most through visual and sensory
prompts—tactile resources and calm, hands-on tools helped unlock their creativity.
        </p>
        <p className="mb-4 text-justify">
        These stories were echoed in our CPD session at School 1, where we shared our child-led
        methods and hands-on techniques with staff. The response was incredibly positive:
        </p>
        <ul className="mb-4 text-left list-disc list-inside">
          <li>
          “Absolutely brilliant – Tenda was fantastic. Lots of new ideas to use.”
          </li>
          <li>
            One parent said,{" "}
            <b>
            “The speaker was amazing – I was fully engaged and found it very interesting.”
            </b>
          </li>
          <li>
          “Really great for building connections between pupils in different ways.”
          </li>
        </ul>
        <p className="mb-4 text-justify">
          This project reminded me of how powerful music can be for
          self-expression and connection. It was a privilege to guide
          these young people through their musical journeys, and I’m
          excited to keep building on what we’ve learned together.
        </p>
      </>
    ),
  },
];

  